import React, {useEffect, useState} from 'react';
import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import Button from "../../../../components/button/button.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import projectUtils from "../../../../utils/project-utils.js";
import ftpUserService from "../../../../services/web/ftp-user-service.js";
import {integrationOptions, translateError} from "../utils/ftp-user-utils.js";

const initialForm = {
    username: "",
    password: "",
    integration: null,
};

const FtpUserForm = () => {
    const {id} = useParams();
    const navigate = navigateHook();

    const [form, setForm] = useState(initialForm);
    const [isLoading, setIsLoading] = useState(false);

    const {data: ftpUser, refetch, isLoading: isFetching} = useQuery({
        queryFn: () => ftpUserService.get(id),
        queryKey: ["ftp-user", id],
        enabled: !!id,
    });

    useEffect(() => {
        if (!ftpUser) return;

        setForm({
            username: ftpUser.username ?? "",
            password: ftpUser.password ?? "",
            integration: ftpUser.integration ?? null,
        });
    }, [ftpUser]);

    const handleInput = ({target}) => setForm(prev => ({...prev, [target.id]: target.value}));

    const handleError = (error, fallback) => {
        console.error(error);

        let message = fallback;
        if (error.response?.status !== 500) {
            message = translateError(error.response?.data?.message ?? error.response?.data, form.username);
        }

        projectUtils.swalErrorMessage("", message, "Ok");
    };

    const submit = () => {
        setIsLoading(true);

        ftpUserService.update({id, ...form})
            .then(() => {
                projectUtils.success(false);
                refetch();
            })
            .catch(error => handleError(error, "Não foi possível salvar."))
            .finally(() => setIsLoading(false));
    };

    const deleteFtpUser = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir usuário FTP "${form.username || id}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (!isConfirmed) return;

                setIsLoading(true);

                ftpUserService.delete(id)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso");
                        navigate("/ftp-users");
                    })
                    .catch(error => handleError(error, "Não foi possível excluir."))
                    .finally(() => setIsLoading(false));
            }
        );
    };

    return (
        <Template isLoading={isLoading || isFetching}>
            <Template.Header>
                <Template.Title>Usuário FTP</Template.Title>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body className={"grid grid-cols-3 gap-4"}>
                        <InputForm
                            id={"username"}
                            label={"Usuário *"}
                            value={form.username}
                            onChange={handleInput}
                        />

                        <InputForm
                            id={"password"}
                            label={"Senha *"}
                            value={form.password}
                            onChange={handleInput}
                        />

                        <SelectComponent
                            id={"integration"}
                            label={"Integração *"}
                            options={integrationOptions}
                            value={integrationOptions.find(option => option.value === form.integration) ?? null}
                            onChange={option => setForm(prev => ({...prev, integration: option?.value ?? null}))}
                        />
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className={"flex justify-end gap-2"}>
                        <Button target={"danger"} onClick={deleteFtpUser} actionFeedbackType='delete'>

                            Excluir
                        </Button>

                        <Button onClick={submit} actionFeedbackType='save'>

                            Salvar
                        </Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default FtpUserForm;